import { useEffect, useRef, useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { stopAllActiveStreams, hasActiveStreams } from '../utils/activeStreams';
import { RecorderContext } from '../context/RecorderContext';

export function MediaStreamCleanup() {
  const location = useLocation();
  const prevLocationRef = useRef(location.pathname);
  const context = useContext(RecorderContext);
  
  useEffect(() => {
    const isOnRecorder = location.pathname.startsWith('/recorder');
    const wasOnRecorder = prevLocationRef.current.startsWith('/recorder');
    
    if (wasOnRecorder && !isOnRecorder && context) {
      context.interruptBlankRecording().then(() => {
        if (hasActiveStreams()) {
          stopAllActiveStreams();
        }
        context.resetRecorderState();
      }).catch(() => {
        if (hasActiveStreams()) {
          stopAllActiveStreams();
        }
        context.resetRecorderState();
      });
    }
    
    prevLocationRef.current = location.pathname;
  }, [location.pathname, context]);
  
  return null;
}
